import { useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../../../components/ui/button";
import { fetchSignedUrl } from "@/lib/fileQueries";

/**
 * Master v5 Prompt 14 — every commercial document download goes
 * through the EXISTING Prompt-11 `/files/{fas_id}/signed-url` route: a
 * fresh, short-lived, re-authorized URL fetched on EVERY click, never
 * cached/reused (§ FilePreviewDrawer.jsx's own rule, applied here).
 */
export function CommercialDownloadButton({ workspaceId, fasId, label, testId }) {
  const [loading, setLoading] = useState(false);

  async function handleClick() {
    setLoading(true);
    try {
      const data = await fetchSignedUrl(workspaceId, fasId);
      window.open(data.signed_url, "_blank", "noopener,noreferrer");
    } catch (e) {
      toast.error(e.body?.detail || "Couldn't authorize that download");
    } finally {
      setLoading(false);
    }
  }

  return (
    <Button variant="outline" size="sm" onClick={handleClick} disabled={loading} data-testid={testId}>
      {loading ? <Loader2 size={13} className="mr-1.5 animate-spin" /> : <Download size={13} className="mr-1.5" />}
      {label || "Download"}
    </Button>
  );
}
